const CompanyManagement = () => import("@/pages/company/index")
const CompanyList = () => import("@/pages/company/list")
const DetailsManagement = () => import("@/pages/company/details")
const VisitManagement = () => import("@/pages/company/visit/list")
const VisitDetails = () => import("@/pages/company/visit/details")
const releaseMangement = () => import("@/pages/company/release/list")
const releaseDetails = () => import("@/pages/company/release/details")

export default [
    {
        path: '/company-management',
        component: CompanyManagement,
        children: [
            {
                path: '',
                component: CompanyList,
                meta: [
                    {
                        name: '企业管理',
                        url: '/company-management'
                    }
                ]
            },
            {
                path: 'company-details/get/:id',
                component: DetailsManagement,
                meta: [
                    {
                        name: '企业管理',
                        url: '/company-management'
                    },
                    {
                        name: '企业详情',
                        url: '/get'
                    }
                ]
            },
            {
                path: 'release-log/get/:id',
                component: releaseMangement,
                meta: [
                    {
                        name: '企业管理',
                        url: '/company-management'
                    },
                    {
                        name: '放行记录',
                        url: '/get'
                    },
                ]
            },
            {
                path: 'release-log/get/:id/details/get/:id',
                component: releaseDetails,
                meta: [
                    {
                        name: '企业管理',
                        url: '/company-management'
                    },
                    {
                        name: '放行记录',
                        url: '/company-management/release-log/get/:id'
                    },
                    {
                        name: '放行申请记录',
                        url: ''
                    },
                ]
            },
            {
                path: 'company-visit/get/:id',
                component: VisitManagement,
                meta: [
                    {
                        name: '企业管理',
                        url: '/company-management'
                    },
                    {
                        name: '访客记录',
                        url: '/get'
                    }
                ]
            },
            {
                path: 'company-visit/get/:id/visit-details/get/:id',
                component: VisitDetails,
                meta: [
                    {
                        name: '企业管理',
                        url: '/company-management'
                    },
                    {
                        name: '访客记录',
                        url: '/company-management/company-visit/get/:id'
                    },
                    {
                        name: '拜访申请记录',
                        url: 'visit-details/get'
                    }
                ]
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/company.js